import { getSelectedOrganisation } from './getOrgMembership';

const userHasV3Permission = (permission: string) => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '{}');
  const selectedOrganisation = getSelectedOrganisation();
  return (
    selectedOrganisation !== null &&
    permissions[selectedOrganisation] &&
    permissions[selectedOrganisation].indexOf(permission) > -1
  );
};

export default userHasV3Permission;
